export function UpperHexagonsdate(key) {
  const constItens = {
    color: '#eee',
    isVisible: true,
    filter_blur: '.2px',
    initial_scale: 1,
    gain_scale: 1,
    duration_go: 10000,
    duration_back: 10000,
    interval_timer: 10000,
    time_animation: '10s',
    interation_count: 'infinite',
    animation_enable: false,
    looping: true,
  };
  const hexagons = [
    {
      icon: '',
      key: 0,
      width_hexagon: '2.2%',
      rotation_from: '15deg',
      rotation_to: '105deg',
      traslate_from: 'translate(3800%, 60%)',
      traslate_to: 'translate(3850%, 40%)',
      opacity_from: 1,
      opacity_to: 0,
      delay_timer: 0,
      ...constItens,
    },
    {
      icon: '',
      key: 1,
      width_hexagon: '1.5%',
      rotation_from: '90deg',
      rotation_to: '0deg',
      traslate_from: 'translate(5820%, 100%)',
      traslate_to: 'translate(5900%, 120%)',
      opacity_from: 0.7,
      opacity_to: 1,
      delay_timer: 0,
      ...constItens,
    },
    {
      icon: '',
      key: 2,
      width_hexagon: '2%',
      rotation_from: '107deg',
      rotation_to: '17deg',
      traslate_from: 'translate(4260%, 200%)',
      traslate_to: 'translate(4200%, 180%)',
      opacity_from: 0.4,
      opacity_to: 0.9,
      delay_timer: 0,
      ...constItens,
    },
    {
      icon: '',
      key: 3,
      width_hexagon: '3%',
      rotation_from: '0deg',
      rotation_to: '180deg',
      traslate_from: 'translate(2860%, 160%)',
      traslate_to: 'translate(2830%, 150%)',
      opacity_from: 0.9,
      opacity_to: 0.1,
      delay_timer: 0,
      ...constItens,
    },
    {
      icon: '',
      key: 4,
      width_hexagon: '5%',
      rotation_from: '90deg',
      rotation_to: '0deg',
      traslate_from: 'translate(1700%, 0%)',
      traslate_to: 'translate(1700%, 0%)',
      opacity_from: 0.5,
      opacity_to: 0.8,
      delay_timer: 0,
      ...constItens,
    },
    {
      icon: '',
      key: 5,
      width_hexagon: '8%',
      rotation_from: '0deg',
      rotation_to: '0deg',
      traslate_from: 'translate(1030%, 70%)',
      traslate_to: 'translate(1030%, 70%)',
      opacity_from: 0.8,
      opacity_to: 0.2,
      delay_timer: 0,
      ...constItens,
    },
  ];
  if (key === 'ALL') return hexagons;
  return hexagons[key];
}

export default UpperHexagonsdate;



// WEBPACK FOOTER //
// ./src/components/UI/Animations/AnimationDate/upperHexagonsDate.jsx